import { apiClient } from '@/lib/apiClient';

import type {
  ContactoLaboratorio,
  ContactoLaboratorioUpdate,
  ContadorProtocoloResponse,
  ContadorProtocoloUpdate,
  Firmante,
  FirmanteUpdate,
} from './types';

const BASE = '/configuracion';

export const configuracionApi = {
  /** 404 si no fue configurado. */
  async getFirmante(signal?: AbortSignal): Promise<Firmante> {
    const response = await apiClient.get<Firmante>(`${BASE}/firmante`, { signal });
    return response.data;
  },

  /** Upsert — crea si no existía. */
  async updateFirmante(data: FirmanteUpdate, signal?: AbortSignal): Promise<Firmante> {
    const response = await apiClient.put<Firmante>(`${BASE}/firmante`, data, { signal });
    return response.data;
  },

  /** 404 si no fue configurado. */
  async getContactoLaboratorio(signal?: AbortSignal): Promise<ContactoLaboratorio> {
    const response = await apiClient.get<ContactoLaboratorio>(
      `${BASE}/contacto-laboratorio`,
      { signal }
    );
    return response.data;
  },

  /** Upsert. */
  async updateContactoLaboratorio(
    data: ContactoLaboratorioUpdate,
    signal?: AbortSignal
  ): Promise<ContactoLaboratorio> {
    const response = await apiClient.put<ContactoLaboratorio>(
      `${BASE}/contacto-laboratorio`,
      data,
      { signal }
    );
    return response.data;
  },

  async getContadorProtocolo(signal?: AbortSignal): Promise<ContadorProtocoloResponse> {
    const response = await apiClient.get<ContadorProtocoloResponse>(
      `${BASE}/contador-protocolo`,
      { signal }
    );
    return response.data;
  },

  async updateContadorProtocolo(
    data: ContadorProtocoloUpdate,
    signal?: AbortSignal
  ): Promise<ContadorProtocoloResponse> {
    const response = await apiClient.put<ContadorProtocoloResponse>(
      `${BASE}/contador-protocolo`,
      data,
      { signal }
    );
    return response.data;
  },
};
